<app-ui-input
  class="search-field"
  label="{{ 'search' | translate }}"
  [control]="searchTerm"
  [showClearButton]="true"
></app-ui-input>
